import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// @atlaskit
import Spinner from '@atlaskit/spinner';

const SpinnerScope = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background-color: #FFFFFF;
`;

const CoverageSpinner = ({ size, ...props }) => (
  <SpinnerScope {...props}>
    <Spinner size={size} />
  </SpinnerScope>
);

CoverageSpinner.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

CoverageSpinner.defaultProps = {
  size: 36,
};

export default CoverageSpinner;
